module.exports = __webpack_public_path__ + "static/Sporting_Grotesque-Bold_web-0be67d55b96904a80079e102ac94b077.eot";